

<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                    <p>Tasks of <span>{{user}}</span></p>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                        <input type="text" placeholder="search user">
                    </form>
                    <i class="bi bi-search" ></i>
                </div>
                </div>
              </div>
                <div class="row">
                   
                  <div class="col-md-9 col-lg-9" style="padding-left: 0;">
                    <!-- <label class="user">Tasks of <span>{{user}}</span></label> -->

                    <div class="panel-group taskStatus-block" id="accordion" role="tablist" aria-multiselectable="true" >
                        <div class="panel panel-default" *ngFor="let user of userTasks;let i = index">
                          <div class="panel-heading" role="tab" id="headingOne{{i}}">
                            <h4 class="panel-title">
                              <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne{{i}}" aria-expanded="true" aria-controls="collapseOne">
                                {{user.taskStatus}} - {{user.count}}
                              </a>
                            </h4>
                          </div>
                          <div id="collapseOne{{i}}" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                            <div class="panel-body">
                                <table class="table">
                                    <thead>
                                      <tr>
                                        <th style="width: 5%;">Id</th>
                                        <th style="width: 15%;">Subject</th>
                                        <th style="width: 15%;">Created By</th>
                                        <th style="width: 15%;">Assigned To</th>
                                        <th style="width: 15%;">Created Date</th>
                                        <th style="width: 10%;">Action</th>

                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let task of user.taskList">
                                        <td>{{task.ttaskId}}</td>
                                        <td>{{task.name}}</td>
                                        <td>{{task.createdByUserName}}</td>
                                        <td>{{task.assignedToUserName}}</td>
                                        <td>{{task.createdDate | date}}</td>
                                        <td>
                                            <i class="bi bi-eye-fill" (click)="getSingleTask(task.taskId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                                        </td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>
                          </div>
                        </div>
                    </div>

                  </div>
                  <div class="col-md-3 col-lg-3" style="border-left: 1px solid #e4e4e4;padding-right: 0;">
                    <div class="usersList">
                      <p *ngFor="let list of usersList" (click)="getAllTaskStatusWiseByAssignedToId(list.userId,list.userName)">{{list.userName}}</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="exampleModalView" tabindex="-1" role="dialog" aria-labelledby="exampleModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="task-content">
          <div class="c-button">
            <div class="c-right">
              <h4> <span style="margin-right: 15px;" *ngIf="ticketId != null && ticketId != ''">TicketId: <span data-toggle="modal" data-target="#ticketview" style="color:rgb(89, 169, 234);cursor: pointer;">{{ticketId}}</span></span> Tasks:</h4>
            </div>
            <div style="align-items: center;">
              <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </div>
          </div>
         <div class="task-data">
    
          <ul class="task-header">
            <li style="width: 9%;">Task-Id</li>
            <li style="width: 9%;">Sl No</li>
            <li>Completed %</li>
            <li>Create on</li>
            <li style="width: 25%;text-align: center;">Status</li>
          </ul>
          <div class="task-table" *ngFor="let task of task;let i = index">
            <ul>
              <li style="width: 9%;">#{{task.ttaskId}}</li>
              <li style="width: 9%;">{{task.taskSlNo}}</li>
              <li style="padding-left: 10px"><input class="percentageInput" (focus)="TaskPercentage(completedPercentage.value)" (focusout)="updateTaskPercentage(completedPercentage.value,task.id)" type="number" #completedPercentage value="{{task.completedPercentage}}"> %</li>

              <li>{{task.createdDate | date}}</li>
              <li style="width: 25%;text-align: center;position: relative;background-color: white;">
                <span (click)="statusDropdown()" class="NEW">{{task.latestTaskStatus}}
                </span>
                <div class="status-dropdown-list" id="status-dropdown-list">
                 <span>ASSIGNED</span>
                 <span>REASSIGNED</span>
                 <span>WORK_IN_PROGRESS</span>
                 <span>PENDING</span>
                 <span>COMPLETED</span>
                 <span>DEFERRED</span>
                 <span>PARTIALLY_COMPLETED</span>
                 <span>FORCE_CLOSED</span>
                 <span>CLOSED</span>
                </div>
              </li>
            </ul>
            <div class="dropdown-data" id="{{i}}">
              <div class="status-content" *ngIf="statusNote">
                <textarea name="" style="height: 70px" [(ngModel)]="note" placeholder="enter status note" class="form-control" id="" cols="30" rows="10"></textarea>
                <div class="col-lg-12" hidden="true">
                  <label class="image-upload-container btn btn-bwm">
                      <!-- <span>Select Image</span> -->
                      <input #imageInput
                             type="file" id="add-image-btn"
                             accept="image/*" hidden="true"
                             (change)="onChange($event)">
                  </label>
                </div>
                <div class=" media-content">
                    <div class="mr-2 image-btn" (click)="addImageBtn()">
                      <span>+ Add Image</span>
                    </div>
                    <div class="media-area" style="border: 1px solid #e5e5e5;border-radius: 5px;height: 80px;width: 100px;overflow: hidden;padding: 1px;" *ngFor="let image of images" class="mr-2">
                        <img src="{{image}}" width="98px" height="78px" style="border-radius: 5px;" alt="" srcset="">
                    </div>
                </div>
                <select name="" id="" (change)="taskStatusDropdown()" [(ngModel)]="taskStatus">
                  <option value="WORK_IN_PROGRESS">WORK_IN_PROGRESS</option>
                  <option value="PENDING">PENDING</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="DEFERRED">DEFERRED</option>
                  <option value="PARTIALLY_COMPLETED">PARTIALLY_COMPLETED</option>
                  <option value="FORCE_CLOSED">FORCE_CLOSED</option>
                  <option value="CLOSED">CLOSED</option>
                </select>
                <button (click)="updateStatus(task.taskId)" *ngIf="updatebutton == false">update status</button>
              </div>
              <div class="assignedToAndTags">
                <div class="assignedTo">
                  <p> <span>Assign to</span> <span class="assignedToButton" *ngIf="task.latestStatus == 'NEW'" (click)="addClass('assignedTo')">: &nbsp; click here to assign</span> <span *ngIf="task.latestStatus != 'NEW'">: &nbsp; {{task.assignedToUserName}}</span> 
                    <span class="assignedToButton" *ngIf="task.latestStatus != 'NEW'" (click)="addClass('assignedTo')"> &nbsp; click here to re-assign</span> 
                  </p>
                </div>
                <!-- <div class="usersTaged">
                  <p *ngIf="task.tagUsers.length == 0"> <span>Users taged</span> <span class="assignedToButton" (click)="addClass('usersTaged')">: &nbsp; click here to Tag Users</span></p>
                  <p *ngIf="task.tagUsers.length != 0"> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
                </div> -->
              </div>
              <p class="task-description"><span>Subject :</span> {{task.name}}</p>
              <p class="task-description"><span>Description :</span> {{task.description}}</p>


              <div class="assign-and-tag-data" id="assign-and-tag-data">
                <div class="assign-to-data">
                  <div class="panel panel-default assign-panel" *ngIf="addClassType == 'assignedTo'">
                    <div class="panel-heading">
                      <h3 class="panel-title">Assign To</h3>
                      <input type="text" class="form-control" [(ngModel)]="assignInput" placeholder="search user">
                    </div>
                    <div class="panel-body">
                      <div *ngIf="task.assignedToUserName == '' || task.assignedToUserName == null">
                        <span *ngFor="let user of usersWithoutCustomers | filter: assignInput">
                          <p (click)="taskAssignToUser(task.taskId,user.userId,'ASSIGNED',user.userName)">{{user.userName}}</p>
                        </span>
                      </div>
                      <div *ngIf="task.assignedToUserName != ''">
                        <span *ngFor="let user of usersWithoutCustomers | filter: assignInput">
                          <p (click)="taskAssignToUser(task.taskId,user.userId,'REASSIGNED',user.userName)">{{user.userName}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default usertags-panel" *ngIf="addClassType == 'usersTaged'">
                    <div class="panel-heading">
                      <h3 class="panel-title">Tag User</h3>
                    </div>
                    <div class="panel-body">
                      <div>
                        <span *ngFor="let user of usersList">
                          <p>{{user.userName}}</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    
              <div class="status-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 50%;">Note</th>
                      <th style="width: 20%;text-align: center;">Status</th>
                      <th style="width: 30%;text-align: center;">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let status of task.status">
                      <td style="width: 50%;">{{status.note}}</td>
                      <td style="width: 20%;text-align: center;">{{status.taskStatus}}</td>
                      <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="taskTable">
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Exp start date</th>
                        <th scope="col">Exp end date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td *ngIf="task.taskExpStartDate != 0">{{task.taskExpStartDate | date:'medium'}}</td>
                        <td *ngIf="task.taskExpEndDate != 0">{{task.taskExpEndDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Act start date</th>
                        <th scope="col">Act end date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td *ngIf="task.taskActStartDate != 0">{{task.taskActStartDate | date:'medium'}}</td>
                        <td *ngIf="task.taskActEndDate != 0">{{task.taskActEndDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="image-container" *ngIf="task.image.length != 0">
                <div class="image-header">
                  <h5>Images/Videos</h5>
                </div>
                <div class="image-content-block">
                  <div class="image-single" *ngFor="let image of task.image">
                    <img src="{{image}}" data-toggle="modal" data-target="#imageView" (click)="viewImage(image)" alt="">
                  </div>
                  <!-- <div class="image-single" *ngFor="let video of task.video">
                    <img src="assets/img/video-play-icon-hd-png.png" data-toggle="modal" data-target="#imageView" (click)="viewVideo(video)" alt="">
                  </div> -->
                </div>
              </div>

            </div>
          </div>
         </div>
        </div>
        <div class="modal-footer" hidden="true">
          <button type="button" id="closeModalButton12" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
</div>